

import { Types, types } from '../types'
const initialState = {

    WaitingGetDocument: false,
    SuccessGetDocument: false,
    ErrorGetDocument: '',
    profileDocuments: [],

    WaitingSaveDocument: false,
    SuccessSaveDocument: false,
    ErrorSaveDocument: '',
    statusSaveDocument: {},

    WaitingDeleteByIdDocument: false,
    SuccessDeleteByIdDocument: false,
    ErrorDeleteByIdDocument: '',
    statusDeleteByIdDocument: {},


    WaitingDeleteDocument: false,
    SuccessDeleteDocument: false,
    ErrorDeleteDocument: '',
    statusDeleteDocument: {}

}

const documentReducer = (state = initialState, { type, action, error }) => {
    switch (type) {
        case types.PROFILE_GET_DOCUMEN_REQUEST:
            {
                return {
                    ...state,
                    WaitingGetDocument: true,
                    SuccessGetDocument: false,
                    ErrorGetDocument: '',
                    // profileDocuments: [],
                }
            }
        case types.PROFILE_GET_DOCUMEN_SUCCESS: {
            return {
                ...state,
                WaitingGetDocument: false,
                SuccessGetDocument: true,
                ErrorGetDocument: '',
                profileDocuments: action.data,
            }
        }
        case types.PROFILE_GET_DOCUMEN_ERROR: {
            return {
                ...state,
                WaitingGetDocument: false,
                SuccessGetDocument: false,
                ErrorGetDocument: 'error',
                profileDocuments: [],
            }
        }
        case types.PROFILE_GET_DOCUMEN_RESET_PROPS: {
            return {
                ...state,
                WaitingGetDocument: false,
                SuccessGetDocument: false,
                ErrorGetDocument: '',
                profileDocuments: [],
            }
        }
        //****************************************************************************************** */
        case types.PROFILE_SAVE_DOCUMEN_REQUEST:
            {
                return {
                    ...state,
                    WaitingSaveDocument: true,
                    SuccessSaveDocument: false,
                    ErrorSaveDocument: '',
                    statusSaveDocument: {},
                }
            }
        case types.PROFILE_SAVE_DOCUMEN_SUCCESS: {
            return {
                ...state,
                WaitingSaveDocument: false,
                SuccessSaveDocument: true,
                ErrorSaveDocument: '',
                statusSaveDocument: action.data,
            }
        }
        case types.PROFILE_SAVE_DOCUMEN_ERROR: {
            return {
                ...state,
                WaitingSaveDocument: false,
                SuccessSaveDocument: false,
                ErrorSaveDocument: 'error',
                statusSaveDocument: {},
            }
        }
        case types.PROFILE_SAVE_DOCUMEN_RESET_PROPS: {
            return {
                ...state,
                WaitingSaveDocument: false,
                SuccessSaveDocument: false,
                ErrorSaveDocument: '',
                statusSaveDocument: {},
            }
        }
        //***************************************************************************************** */
        case types.PROFILE_DELETE_BY_ID_DOCUMENT_REQUEST:
            {
                return {
                    ...state,
                    WaitingDeleteByIdDocument: true,
                    SuccessDeleteByIdDocument: false,
                    ErrorDeleteByIdDocument: '',
                    statusDeleteByIdDocument: {},
                }
            }
        case types.PROFILE_DELETE_BY_ID_DOCUMENT_SUCCESS: {
            return {
                ...state,
                WaitingDeleteByIdDocument: false,
                SuccessDeleteByIdDocument: true,
                ErrorDeleteByIdDocument: '',
                statusDeleteByIdDocument: action.data,
            }
        }
        case types.PROFILE_DELETE_BY_ID_DOCUMENT_ERROR: {
            return {
                ...state,
                WaitingDeleteByIdDocument: false,
                SuccessDeleteByIdDocument: true,
                ErrorDeleteByIdDocument: '',
                statusDeleteByIdDocument: {},
            }
        }
        //******************************************************************************************** */
        case types.PROFILE_DELETE_DOCUMENT_REQUEST:
            {
                return {
                    ...state,
                    WaitingDeleteDocument: true,
                    SuccessDeleteDocument: false,
                    ErrorDeleteDocument: '',
                    statusDeleteDocument: {},
                }
            }
        case types.PROFILE_DELETE_DOCUMENT_SUCCESS: {
            return {
                ...state,
                WaitingDeleteDocument: false,
                SuccessDeleteDocument: true,
                ErrorDeleteDocument: '',
                statusDeleteDocument: action.data,
            }
        }
        case types.PROFILE_DELETE_DOCUMENT_ERROR: {
            return {
                ...state,
                WaitingDeleteDocument: false,
                SuccessDeleteDocument: true,
                ErrorDeleteDocument: {},
                statusDeleteDocument: action.data,
            }
        }
        //******************************************************************************************************* */

        case Types.GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_REQUEST:
            {
                return {
                    ...state,
                    getNationalCardCustomerDocumentStatusPending: true,
                    getNationalCardCustomerDocumentStatusSuccess: false,
                    getNationalCardCustomerDocumentStatusError: ''
                }
            }
        case Types.GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_SUCCESS: {
            return {
                ...state,
                getNationalCardCustomerDocumentStatusPending: false,
                getNationalCardCustomerDocumentStatusSuccess: true,
                getNationalCardCustomerDocumentStatus: action.data,
            }
        }
        case Types.GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_ERROR: {
            return {
                ...state,
                getNationalCardCustomerDocumentStatusPending: false,
                getNationalCardCustomerDocumentStatusError: 'error',
            }
        }
        case types.PROFILE_DELETE_DOCUMEN_RESET_PROPS: {
            return {
                ...state,
                WaitingDeleteDocument: false,
                SuccessDeleteDocument: false,
                ErrorDeleteDocument: '',
                statusDeleteDocument: {},

            }
        }



        default:
            return state
    }
}

export default documentReducer;